/* Franco Leone discount popup */

/* Checkbox fix: the popup form styles every <input> as a 68px-tall text field,
   which made the consent checkboxes huge and invisible. Reset them here. */
(function injectDiscountFixes() {
  if (document.getElementById('franco-discount-fixes')) return;
  const style = document.createElement('style');
  style.id = 'franco-discount-fixes';
  style.textContent = `
    .franco-discount__consent {
      cursor: pointer;
    }

    .franco-discount__consent input[type='checkbox'] {
      -webkit-appearance: checkbox !important;
      appearance: auto !important;
      display: inline-block !important;
      position: static !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      flex: 0 0 18px !important;
      width: 18px !important;
      height: 18px !important;
      min-width: 18px !important;
      min-height: 18px !important;
      margin: 2px 0 0 !important;
      padding: 0 !important;
      accent-color: #FD5F0D;
      cursor: pointer;
    }

    /* Code is easy to select manually if automatic copy is ever blocked */
    .franco-discount code[data-discount-code-output] {
      -webkit-user-select: all;
      user-select: all;
    }
  `;
  document.head.appendChild(style);
})();

document.querySelectorAll('[data-franco-discount]').forEach((root) => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const overlay = root.querySelector('[data-discount-overlay]');
  const dialog = root.querySelector('[data-discount-dialog]');
  const badge = root.querySelector('[data-discount-open]');
  const steps = root.querySelectorAll('[data-discount-step]');
  const storageKey = 'francoDiscountDismissedUntil';
  const showStep = (name) => steps.forEach((step) => step.classList.toggle('is-active', step.dataset.discountStep === name));

  const remember = () => {
    const days = Number(root.dataset.frequencyDays || 7);
    try { localStorage.setItem(storageKey, String(Date.now() + days * 86400000)); } catch (error) { /* storage unavailable */ }
  };

  /* Always hides the green overlay, however the dialog was closed */
  const reset = () => {
    overlay.hidden = true;
    badge.classList.remove('is-open');
  };

  const open = () => {
    overlay.hidden = false;
    badge.classList.add('is-open');
    /* Popup now starts directly at the email step */
    showStep('email');
    if (!dialog.open) {
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
    }
  };

  const close = () => {
    if (dialog.open) dialog.close();
    reset();
    remember();
  };

  let dismissedUntil = 0;
  try { dismissedUntil = Number(localStorage.getItem(storageKey) || 0); } catch (error) { /* storage unavailable */ }

  badge.addEventListener('click', open);
  root.querySelectorAll('[data-discount-close]').forEach((el) => el.addEventListener('click', close));

  /* Esc key, browser back gesture or any native close: clean up the overlay too */
  dialog.addEventListener('close', () => { reset(); remember(); });

  /* Click on the dimmed area outside the dialog closes it */
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (outside) close();
  });
  overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });

  /* Page restored from the back/forward cache: never leave a stuck overlay */
  window.addEventListener('pageshow', () => { if (!dialog.open) reset(); });

  root.querySelector('[data-discount-email-next]')?.addEventListener('click', () => {
    const email = root.querySelector('[data-discount-email]');
    const consent = root.querySelector('[data-discount-email-consent]');
    if (!email || !email.checkValidity()) { email?.reportValidity(); return; }
    if (!consent || !consent.checked) { consent?.reportValidity(); return; }
    root.dataset.email = email.value;
    showStep('phone');
  });

  root.querySelector('[data-discount-activate]')?.addEventListener('click', () => {
    const phone = root.querySelector('[data-discount-phone]');
    const consent = root.querySelector('[data-discount-sms-consent]');
    const error = root.querySelector('[data-discount-error]');
    const digits = (phone?.value || '').replace(/\D/g, '');
    const showError = (message) => { if (error) { error.hidden = false; error.textContent = message; } };
    if (digits.length !== 10 || !/^[6-9]/.test(digits)) { showError('Enter a valid 10-digit Indian mobile number.'); return; }
    if (!consent || !consent.checked) { showError('Please accept the consent to continue.'); return; }
    if (error) error.hidden = true;
    root.dataset.phone = '+91' + digits;
    showStep(root.dataset.higherCode ? 'higher' : 'success');
  });

  /* Higher offer: show the higher code and make Shop now apply that same code */
  root.querySelector('[data-discount-higher]')?.addEventListener('click', () => {
    const code = root.dataset.higherCode || root.dataset.discountCode;
    const out = root.querySelector('[data-discount-code-output]');
    if (out) out.textContent = code;
    const link = root.querySelector('a[href^="/discount/"]');
    if (link && code) link.href = '/discount/' + encodeURIComponent(code) + '?redirect=/collections/all';
    showStep('success');
  });
  root.querySelector('[data-discount-finish]')?.addEventListener('click', () => showStep('success'));

  /* Copy code.
     The first copy attempt runs SYNCHRONOUSLY inside the click, so the browser
     still sees a user gesture (needed by Safari / iOS and by sandboxed iframes
     such as the theme preview, where the async Clipboard API is blocked).
     Order: execCommand -> async Clipboard API -> select the code for manual copy. */
  const legacyCopy = (text) => {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.setAttribute('aria-hidden', 'true');
    area.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;pointer-events:none;font-size:16px;';
    /* Must live inside the dialog: everything outside a modal dialog is inert */
    (dialog.open ? dialog : document.body).appendChild(area);
    let ok = false;
    try {
      area.focus({ preventScroll: true });
      area.select();
      area.setSelectionRange(0, text.length);
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    area.remove();
    return ok;
  };

  const copyButton = root.querySelector('[data-discount-copy]');
  let copyTimer;
  copyButton?.addEventListener('click', (event) => {
    event.preventDefault();
    const output = root.querySelector('[data-discount-code-output]');
    const code = output?.textContent?.trim();
    if (!code) return;

    const original = copyButton.dataset.label || copyButton.textContent.trim();
    copyButton.dataset.label = original;

    const feedback = (message) => {
      copyButton.textContent = message;
      window.clearTimeout(copyTimer);
      copyTimer = window.setTimeout(() => { copyButton.textContent = original; }, 2000);
    };

    /* Last resort: select the code so it can be copied manually */
    const selectCode = () => {
      if (!output) return;
      const range = document.createRange();
      range.selectNodeContents(output);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      feedback('Code selected - copy it');
    };

    const copied = legacyCopy(code);
    copyButton.focus({ preventScroll: true });

    if (copied) {
      feedback('Copied!');
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => feedback('Copied!'), selectCode);
    } else {
      selectCode();
    }
  });

  if (Date.now() > dismissedUntil) window.setTimeout(() => badge.classList.add('is-visible'), 1200);
});